import React, {createRef} from "react";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import AttachmentsCollection from "../../../../model2/attachment/attachments";
import {AttachFileMode} from "../../../../gd-components/files/const";
import ButtonAddAttachmentLink from "../../../../gd-components/files/add-attachment-button/add-link";
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import Attachment from "../../../../model2/attachment/attachment";
import ApiAttachment from "../../../../gd/api/attachment";
import {AttachmentSystemType} from "../../../../model2/attachment/@types";

// const debug = "FieldAttachment_FormElementView"
const debug = false

type State = {
    attachments :   AttachmentsCollection
    loading     :   boolean
}

export default class FieldAttachment_FormElementView extends React.Component<FieldFormElementViewProps, State> {

    public attachmentsRef   : React.RefObject<any>
    public domElementId     : ID

    constructor(props: FieldFormElementViewProps) {
        super(props)

        const attachment = this.props.field.getViewValue(this.props.model)

        this.attachmentsRef = createRef()
        this.domElementId   = "item-" + gd.utils.generateUIDWithCollisionChecking()

        this.state = {
            attachments :   !!attachment ? new AttachmentsCollection([attachment]) : new AttachmentsCollection([]),
            loading     :   false,
        }
    }

    componentWillUnmount() {
        this.attachmentsRef.current.toggleDropzone(false)
    }

    onSelect = (dataFrom: "local" | "google-drive")=>{
        this.attachmentsRef.current.selectAttachment(dataFrom)
    }

    onChange = (value: AttachmentsCollection) => {

        if(value.isEmpty){
            this.attachmentsRef.current.resetAttachments()
            this.setState({loading: false})
        }

        this.setState({
            attachments: value
        })

        if (this.props.onChange) {
            // @ts-ignore
            this.props.onChange(value.singleAttachment, this.onCancelChange);
        }
    }

    startLoading = ()=>{
        this.setState({loading: true})
    }

    finishLoading = (attachment: Attachment)=>{
        this.setState({loading: false})
        ApiAttachment.save([attachment])
    }

    render(){

        const classes = Classes("attachments-container flex-column-left-center", this.props.className)

        return(
            <div id={this.domElementId} className={classes}>
                <AttachmentsManager  ref                    = {this.attachmentsRef}
                                     mode                   = {AttachFileMode.VIEW_AND_EDIT}
                                     onlySingleFile         = {true}
                                     systemType             = {AttachmentSystemType.CUSTOM}
                                     className              = "m-t-15"
                                     attachmentsCollection  = {this.state.attachments}
                                     onNewUploadStarted     = {this.startLoading}
                                     saveNewUpload          = {this.finishLoading}
                                     dropzoneDOMElementId   = {this.domElementId}
                                     onChange               = {this.onChange} />
                {this.state.attachments.isEmpty && !this.state.loading && (
                    <div className="flex-row-left-center m-t-10">
                        <ButtonAddAttachmentLink onSelect={this.onSelect} disabled={this.props.disabled}/>
                    </div>
                )}
            </div>
        )
    }
}
